export function registerPlanformServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator) || import.meta.env.DEV) return;

  const basePath = import.meta.env.BASE_URL;
  const appOrigin = window.location.origin;
  const serviceWorkerUrl = new URL("sw.js", new URL(basePath, appOrigin)).href;
  const scope = new URL(basePath, appOrigin).pathname;

  void navigator.serviceWorker.register(serviceWorkerUrl, { scope }).catch(() => {
    // Installing the app is optional. The normal browser experience remains available.
  });
}
